// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__21c9f","icon":"Toast_icon__1sScS","success":"Toast_success__1RiCm","fail":"Toast_fail__KeKK8"};